(function () {
  'use strict';
  const settingsNode = document.querySelector('[data-ef-project-settings]');
  if (!settingsNode) return;
  const settings = JSON.parse(settingsNode.textContent);
  const key = 'ef-project-v1';
  const historyKey = 'ef-project-history-v1';
  let memory = null;
  let persistent = true;
  const dataCache = new Map();
  const blank = () => ({version:1,name:'My room',mode:'home',items:[]});
  const text = (value, max) => typeof value === 'string' ? value.trim().slice(0,max) : '';
  const safeId = value => /^\d{1,20}$/.test(String(value || '')) ? String(value) : '';
  const safeHandle = value => /^[a-z0-9][a-z0-9-]{0,199}$/.test(value || '') ? value : '';
  const validChoices = ['considering','like','replace'];
  function normalise(raw) {
    if (!raw || raw.version !== 1 || !Array.isArray(raw.items) || raw.items.length > 30) throw Error('This project link is not valid.');
    return {
      version:1,
      name:text(raw.name,80) || 'My room',
      mode:raw.mode==='designer'?'designer':'home',
      items:raw.items.map((item,index) => {
        const handle=safeHandle(item.handle);
        const variantId=safeId(item.variantId);
        if (!handle || !variantId || !Number.isInteger(item.quantity) || item.quantity<1 || item.quantity>99) throw Error('This project contains an invalid product selection.');
        const properties=Array.isArray(item.properties) ? item.properties.slice(0,20).map(pair => {
          if (!Array.isArray(pair) || pair.length !== 2) throw Error('Invalid product specification.');
          return [text(pair[0],120),text(pair[1],700)];
        }).filter(pair=>pair[0]&&pair[1]) : [];
        return {id:String(index)+'-'+variantId,handle,variantId,quantity:item.quantity,properties,choice:validChoices.includes(item.choice)?item.choice:'considering',note:text(item.note,240),room:text(item.room,50)};
      })
    };
  }
  function read() {
    if (memory) return structuredClone(memory);
    try { const stored=localStorage.getItem(key); return stored ? normalise(JSON.parse(stored)) : blank(); }
    catch (error) { persistent=false; return blank(); }
  }
  function save(project) {
    memory=normalise(project);
    try { localStorage.setItem(key,JSON.stringify(memory)); persistent=true; }
    catch (error) { persistent=false; }
    document.dispatchEvent(new CustomEvent('ef:project-updated'));
    return persistent;
  }
  function encode(project) {
    const compact=normalise(project);
    const bytes=new TextEncoder().encode(JSON.stringify(compact));
    let binary='';
    for (const byte of bytes) binary+=String.fromCharCode(byte);
    const encoded=btoa(binary).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
    if (encoded.length>24000) throw Error('This project is too large for a sharing link. Shorten the project notes or remove some items, then try again.');
    return 'v1.'+encoded;
  }
  function decode(encoded) {
    if (!encoded.startsWith('v1.') || encoded.length>24003) throw Error('This project link is not valid.');
    let raw=encoded.slice(3).replace(/-/g,'+').replace(/_/g,'/');
    raw+='='.repeat((4-raw.length%4)%4);
    return normalise(JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(raw),c=>c.charCodeAt(0)))));
  }
  function shareUrl(project) {
    const url=new URL(settings.projectUrl,location.origin);
    url.hash='project='+encode(project);
    return url.href;
  }
  function productUrl(item) {
    const url=new URL(settings.root+'products/'+item.handle,location.origin);
    url.searchParams.set('variant',item.variantId);
    return url;
  }
  async function productData(item, force) {
    const cacheKey=item.handle+':'+item.variantId;
    if (!force && dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const request=(async()=>{
      const url=productUrl(item);
      url.searchParams.set('section_id','project-product-data');
      const response=await fetch(url.href,{credentials:'same-origin',signal:AbortSignal.timeout(18000)});
      if (!response.ok) throw Error('Product details could not be loaded.');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const script=doc.querySelector('[data-ef-project-product]');
      if (!script) throw Error('Product details could not be loaded.');
      const data=JSON.parse(script.textContent);
      if (String(data.variantId)!==item.variantId || data.handle!==item.handle) throw Error('This configuration needs to be checked by our team.');
      if (!Number.isFinite(data.price) || data.price<0 || !/^[A-Z]{3}$/.test(data.currency)) throw Error('The current price is unavailable.');
      return data;
    })();
    dataCache.set(cacheKey,request);
    try { return await request; } catch(error) { dataCache.delete(cacheKey); throw error; }
  }
  function money(amount,currency) {
    return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency||settings.currency}).format(amount/100);
  }
  function counts() {
    const project=read();
    const quantity=project.items.reduce((sum,item)=>sum+item.quantity,0);
    document.querySelectorAll('a[href]').forEach(link=>{
      try {
        if (new URL(link.href).pathname!==new URL(settings.projectUrl,location.origin).pathname || new URL(link.href).hash) return;
        if (!link.closest('header,header-drawer,footer')) return;
        let count=link.querySelector('.ef-project-nav-count');
        if (!count) { count=document.createElement('span');count.className='ef-project-nav-count';link.append(count); }
        count.textContent=quantity ? '('+quantity+')' : '';
      } catch(error) {}
    });
  }
  async function add(button) {
    const wrapper=button.closest('.ef-project-action');
    const status=wrapper.querySelector('[role=status]');
    const form=button.dataset.productForm?document.getElementById(button.dataset.productForm):button.closest('form');
    const directId=safeId(button.dataset.projectVariant);
    const choice=button.closest('product-choice');
    if (choice && typeof choice.update==='function') choice.update();
    const variantInput=form?.querySelector('[name=id]');
    const variantId=directId||safeId(variantInput?.value);
    if (!variantId || (!directId && variantInput?.disabled)) {status.textContent='Choose your product options first.';return;}
    if (!directId && (!form || !form.reportValidity())) {status.textContent='Complete the required options and finish codes before adding this item.';return;}
    const formData=directId?null:new FormData(form);
    const quantity=Number(directId?button.dataset.projectQuantity||1:formData.get('quantity')||1);
    if (!Number.isInteger(quantity)||quantity<1||quantity>99) {status.textContent='Choose a quantity between 1 and 99.';return;}
    const properties=[];
    if(formData) for(const [name,value] of formData.entries()) {
      const match=name.match(/^properties\[(.+)\]$/);
      if (match && typeof value==='string' && value.trim()) properties.push([text(match[1],120),text(value,700)]);
    }
    properties.sort((a,b)=>a[0].localeCompare(b[0]));
    const item={id:crypto.randomUUID(),handle:safeHandle(button.dataset.productHandle),variantId,quantity,properties,choice:'considering',note:'',room:''};
    button.disabled=true;
    status.textContent='Adding your selection…';
    try {
      const current=await productData(item);
      if (quantity<(current.min||1) || quantity>Math.min(current.max||99,99) || (quantity-(current.min||1))%(current.step||1)!==0) throw Error('Check this configuration’s quantity requirements.');
      const project=read();
      const existing=project.items.find(row=>row.handle===item.handle&&row.variantId===item.variantId&&JSON.stringify(row.properties)===JSON.stringify(item.properties)&&(row.room||'')==='');
      if (existing) {
        if (existing.quantity+quantity>Math.min(current.max||99,99)) throw Error('This item is already in your project. Set its quantity on the project page.');
        existing.quantity+=quantity;
      } else {
        if (project.items.length>=30) throw Error('Your project already contains 30 configurations. Remove an item before adding another.');
        project.items.push(item);
      }
      const stored=save(project);
      status.textContent=stored?'Added to your project. Your selected options have been saved.':'Added for this visit. Storage is unavailable; open your project and copy its link to keep it.';
    } catch(error) {status.textContent=error.message||'We could not add this item. Please try again.';}
    finally {button.disabled=false;}
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-ef-project-add]');
    if (button) add(button);
  });
  document.addEventListener('ef:project-updated',counts);
  window.addEventListener('storage',event=>{if(event.key===key){memory=null;document.dispatchEvent(new CustomEvent('ef:project-updated'));}});
  counts();
  const root=document.querySelector('[data-ef-project-builder]');
  window.EFProject={read,save,normalise,shareUrl,productData,money,productUrl,decode,encode};
  if (!root) return;
  let project=read();
  if(new URLSearchParams(location.search).get('mode')==='designer')project.mode='designer';
  let shared=false;
  let loaded=new Map();
  let rendering=0;
  const find=selector=>root.querySelector(selector);
  const status=find('[data-project-status]');
  const name=find('[data-project-name]');
  const list=find('[data-project-items]');
  const form=find('form');
  const share=find('[data-project-share]');
  const submit=find('[data-project-submit]');
  const country=find('[data-project-country]');
  const mode=find('[data-project-mode]');
  const toolText=JSON.parse(document.querySelector('[data-ef-discovery-settings]')?.textContent||'{"text":{}}').text;
  mode?.addEventListener('change',()=>{project.mode=mode.value;persist();render();});
  if (country.options.length && country.options[0].value==='---') {country.options[0].value='';country.options[0].textContent='Choose a country';}
  try {
    const encoded=new URLSearchParams(location.hash.slice(1)).get('project');
    if (encoded) { project=decode(encoded);shared=true; }
  } catch(error) { status.textContent=error.message+' Your saved project is shown below.'; }
  let savedProjects=[];
  function refreshHistory() {
    try {savedProjects=JSON.parse(localStorage.getItem(historyKey)||'[]').slice(0,5).map(normalise);} catch(error){savedProjects=[];}
    const select=find('[data-project-history]');
    select.replaceChildren(new Option('Choose a saved project',''));
    savedProjects.forEach((entry,index)=>select.add(new Option(entry.name+' ('+entry.items.length+' configurations)',String(index))));
    find('[data-project-restore]').disabled=true;
    select.disabled=!savedProjects.length||shared;
    find('[data-project-new]').disabled=shared;
  }
  function archiveCurrent() {
    if(!project.items.length)return;
    savedProjects.unshift(normalise(project));
    savedProjects=savedProjects.slice(0,5);
    try{localStorage.setItem(historyKey,JSON.stringify(savedProjects));}catch(error){status.textContent='Storage is unavailable. Copy your current project link before starting another.';throw error;}
  }
  find('[data-project-history]').addEventListener('change',event=>{find('[data-project-restore]').disabled=event.target.value==='';});
  find('[data-project-new]').addEventListener('click',()=>{try{archiveCurrent();project=blank();persist();refreshHistory();render();status.textContent='A new project is ready. Your previous selection is in Saved projects.';}catch(error){}});
  find('[data-project-restore]').addEventListener('click',()=>{
    const selected=savedProjects[Number(find('[data-project-history]').value)];
    if(!selected||shared)return;
    try{archiveCurrent();project=structuredClone(selected);persist();refreshHistory();render();status.textContent='Saved project opened.';}catch(error){}
  });
  function saveStatus() {
    find('[data-project-save-status]').textContent=shared?'Shared snapshot — save a copy to edit.':persistent?'Saved automatically on this device.':'Storage is unavailable. Copy the sharing link to keep this project.';
  }
  function persist() { if (!shared) save(project);saveStatus();updateSummary(); }
  function totalText() {
    if (!project.items.length) return money(0,settings.currency);
    const currencies=new Set();
    let total=0;
    let missing=false;
    for(const item of project.items) {
      const data=loaded.get(item.id);
      if (!data) {missing=true;continue;}
      total+=data.price*item.quantity;currencies.add(data.currency);
    }
    if (missing || currencies.size!==1) return 'To be confirmed';
    return money(total,[...currencies][0]);
  }
  function requestBody() {
    const lines=[project.mode==='designer'?'DESIGNER PROJECT QUOTATION':'BUNDLE DISCOUNT REQUEST','Please provide a personal offer and a discount on the complete project.','Project: '+project.name,'Project type: '+(project.mode==='designer'?'Designer / client project':'My home'),'Displayed product total: '+totalText(),'Delivery and lead times: please confirm.',''];
    project.items.forEach((item,index)=>{
      const data=loaded.get(item.id);
      lines.push((index+1)+'. '+(data?data.title:item.handle),'Brand: '+(data?.vendor||'Please check'),'Variant ID: '+item.variantId,'Configuration: '+(data?.variant||'Please check this configuration'),'SKU: '+(data?.sku||'Not specified'),'Quantity: '+item.quantity,'Room: '+(item.room||'Unassigned room'));
      if(data)lines.push('Unit price: '+money(data.price,data.currency),'Line total: '+money(data.price*item.quantity,data.currency));
      else lines.push('Price/configuration could not be verified — please check.');
      for(const [label,value] of item.properties)lines.push(label+': '+value);
      lines.push('Customer choice: '+({like:'I like this',considering:'Considering',replace:'Find an alternative'})[item.choice]);
      if(item.note)lines.push('Project note: '+item.note);
      lines.push('Product: '+productUrl(item).href,'');
    });
    try {lines.push('Project snapshot: '+shareUrl(project));} catch(error) {}
    return lines.join('\n');
  }
  function updateSummary() {
    const designer=project.mode==='designer';
    find('[data-project-offer-heading]').textContent=designer?(toolText.designer_offer||'Request a project quotation'):'Request a bundle discount';
    find('[data-project-request-type]').value=designer?'Designer project quotation':'Bundle discount request';
    submit.textContent=designer?(toolText.designer_offer||'Request a project quotation'):'Get a discount on my project';
    find('[data-project-total]').textContent=totalText();
    find('[data-project-item-count]').textContent=project.items.length+' configuration'+(project.items.length===1?'':'s');
    find('[data-project-contact-name]').value=project.name;
    find('[data-project-contact-body]').value=requestBody();
    submit.disabled=!project.items.length||list.getAttribute('aria-busy')==='true';
    share.disabled=!project.items.length;
  }
  function updateItem(item, data, row) {
    find('[data-project-form-status]').textContent='';
    if (data) {
      row.querySelector('[data-row-total]').textContent=money(data.price*item.quantity,data.currency);
      row.querySelector('[data-row-unit]').textContent=money(data.price,data.currency)+' each';
    }
    persist();
  }
  function makeRow(item,data,error) {
    const row=find('[data-project-row]').content.firstElementChild.cloneNode(true);
    const get=selector=>row.querySelector(selector);
    const link=productUrl(item).href;
    get('[data-row-link]').href=link;
    const image=get('[data-row-image]');
    if(data?.image){const url=new URL(data.image,location.origin);if(url.protocol==='https:'){image.src=url.href;image.alt=data.title;}}else image.hidden=true;
    get('[data-row-title]').textContent=data?.title||item.handle.replace(/-/g,' ');
    get('[data-row-title]').href=link;
    get('[data-row-brand]').textContent=data?.vendor||'Configuration to check';
    get('[data-row-variant]').textContent=data?.variant==='Default Title'?'':data?.variant||'Variant '+item.variantId;
    get('[data-row-sku]').textContent=data?.sku?'SKU: '+data.sku:'';
    const properties=get('[data-row-properties]');
    for(const [label,value] of item.properties){const dt=document.createElement('dt');dt.textContent=label;const dd=document.createElement('dd');dd.textContent=value;properties.append(dt,dd);}
    get('[data-row-spec]').hidden=!item.properties.length;
    const warning=get('[data-row-warning]');
    if(error||data?.available===false){warning.hidden=false;warning.textContent=error?'Current details could not be verified. We will check this configuration in your offer.':'This configuration is currently unavailable online. Ask us to confirm availability or suggest an alternative.';}
    get('[data-row-total]').textContent=data?money(data.price*item.quantity,data.currency):'Price to confirm';
    get('[data-row-unit]').textContent=data?money(data.price,data.currency)+' each':'';
    const quantity=get('[data-row-quantity]');
    quantity.value=item.quantity;
    quantity.required=true;
    quantity.min=data?.min||1;
    quantity.step=data?.step||1;
    quantity.max=Math.min(data?.max||99,99);
    quantity.disabled=shared;
    quantity.addEventListener('input',()=>{if(!quantity.validity.valid)return;item.quantity=Number(quantity.value);updateItem(item,data,row);});
    quantity.addEventListener('change',()=>{if(!quantity.reportValidity())return;item.quantity=Number(quantity.value);updateItem(item,data,row);});
    const choice=get('[data-row-choice]');
    choice.value=item.choice;choice.disabled=shared;
    choice.addEventListener('change',()=>{item.choice=choice.value;persist();});
    const roomInput=get('[data-row-room]');
    roomInput.value=item.room||'';roomInput.readOnly=shared;
    roomInput.addEventListener('input',()=>{item.room=text(roomInput.value,50);persist();});
    roomInput.addEventListener('change',()=>{item.room=text(roomInput.value,50);persist();render();});
    const note=get('[data-row-note]');
    note.value=item.note;note.readOnly=shared;
    note.addEventListener('input',()=>{item.note=text(note.value,240);persist();});
    const remove=get('[data-row-remove]');
    remove.disabled=shared;
    remove.setAttribute('aria-label','Remove '+(data?.title||item.handle)+' from project');
    remove.addEventListener('click',()=>{project.items=project.items.filter(entry=>entry.id!==item.id);persist();render();});
    return row;
  }
  async function render() {
    const revision=++rendering;
    name.value=project.name;name.readOnly=shared;
    if(mode){mode.value=project.mode||'home';mode.disabled=shared;}
    find('[data-project-shared]').hidden=!shared;
    find('[data-project-empty]').hidden=!!project.items.length;
    list.setAttribute('aria-busy','true');
    list.replaceChildren();
    loaded=new Map();
    saveStatus();updateSummary();
    refreshHistory();
    const rows=await Promise.all(project.items.map(async item=>{
      try{const data=await productData(item);return {item,data};}catch(error){return {item,error};}
    }));
    if(revision!==rendering)return;
    const groups=[...new Set(rows.map(row=>row.item.room||''))];
    const grouped=project.mode==='designer'||groups.some(Boolean);
    for(const group of groups){if(grouped){const heading=document.createElement('h3');heading.className='ef-project__room-group';heading.textContent=group||toolText.ungrouped||'Unassigned room';list.append(heading);}for(const {item,data,error} of rows.filter(row=>(row.item.room||'')===group)){if(data)loaded.set(item.id,data);list.append(makeRow(item,data,error));}}
    list.setAttribute('aria-busy','false');updateSummary();
  }
  name.addEventListener('input',()=>{if(!shared){project.name=text(name.value,80)||'My room';persist();}});
  find('[data-project-import]').addEventListener('click',()=>{
    try {
      const previous=read();
      if(previous.items.length){const history=JSON.parse(localStorage.getItem(historyKey)||'[]');history.unshift(previous);localStorage.setItem(historyKey,JSON.stringify(history.slice(0,5)));}
    } catch(error) {}
    shared=false;
    persist();
    if(location.hash.startsWith('#project='))history.replaceState(null,'',location.pathname+location.search);
    status.textContent='A copy has been saved on this device. Edit it, then copy a new link to share your changes.';
    render();
  });
  share.addEventListener('click',async()=>{
    try {
      for(const input of list.querySelectorAll('input[type=number]'))if(!input.reportValidity())throw Error('Check the quantities before sharing your project.');
      const link=shareUrl(project);
      const field=find('[data-project-share-link]');
      field.value=link;
      try{await navigator.clipboard.writeText(link);find('[data-project-share-fallback]').hidden=true;status.textContent='Sharing link copied. It contains your product selections and project notes, without your enquiry email or delivery country.';}
      catch(error){find('[data-project-share-fallback]').hidden=false;field.focus();field.select();status.textContent='Select and copy the sharing link below.';}
    } catch(error){status.textContent=error.message;}
  });
  form.addEventListener('submit',event=>{
    if(!project.items.length){event.preventDefault();find('[data-project-form-status]').textContent='Add at least one product to your project first.';return;}
    if(list.getAttribute('aria-busy')==='true'){event.preventDefault();find('[data-project-form-status]').textContent='Wait while we load your selected products.';return;}
    for(const input of list.querySelectorAll('input[type=number]')){if(!input.reportValidity()){event.preventDefault();find('[data-project-form-status]').textContent='Check the quantities in your project.';return;}}
    project.name=text(name.value,80)||'My room';
    updateSummary();
    if(!form.reportValidity()){event.preventDefault();return;}
    find('[data-project-form-status]').textContent='Sending your project request…';
  });
  document.addEventListener('ef:project-updated',()=>{if(!shared&&document.activeElement!==name&&!root.contains(document.activeElement)){project=read();render();}});
  window.addEventListener('hashchange',()=>{
    try{const encoded=new URLSearchParams(location.hash.slice(1)).get('project');project=encoded?decode(encoded):read();shared=!!encoded;status.textContent='';}
    catch(error){project=read();shared=false;status.textContent=error.message+' Your saved project is shown below.';}
    render();
  });
  render();
})();
